import posNotificationInstance from '../instance'

const generateWatchPairingCode = () => {
	return posNotificationInstance.post('watchPairingCodes')
}

export default generateWatchPairingCode
